const sliderSections = document.querySelectorAll( ".slider-section" );
sliderSections.forEach( ( section, i ) => {
  let sectionIdx = 0;
  const overlays = section.querySelectorAll( ".slider .group .overlay" );
  const slides = section.querySelectorAll( ".slider .slide" );

  const slider = tns( {
    container: section.querySelector( ".slider" ),
    items: 1, // Ensure only one slide is shown at a time
    autoplay: false,
    controls: true,
    nav: false,
    loop: true,
    autoplayButtonOutput: false,
    controlsText: [ '', '' ],
    controlsContainer: section.querySelector( ".slider-controls" ),
    speed: 400,
    gutter: 16,
    fixedHeight: true,
    responsive: {
      0: {
        items: 1.5,
        gutter: 16,
        fixedWidth: 325,
      },
      768: {
        items: 1,
        gutter: 16,
        fixedWidth: 450,
      },
      1024: {
        items: 2,
        gutter: 16,
        fixedWidth: 450,
      },
    },
    onInit: function ( info ) {
      console.log( "onInit", info.index );
      sectionIdx = info.index;
      handleOpacity();
    },
  } );

  slider.events.on( "indexChanged", function ( info ) {
    console.log( "info", info.index );
    sectionIdx = info.index;
    handleOpacity();
  } );

  function handleOpacity () {
    let overlays2 = section.querySelectorAll( ".slider .group .overlay" );
    for ( let i = 0; i < overlays2.length; i++ ) {
      overlays2[ i ].style.opacity =
        i > sectionIdx + 1 || i < sectionIdx ? 0.85 : 0;
    }
    console.log( "sectionIdx", JSON.stringify( sectionIdx, null, 2 ) );
  }
  handleOpacity();
} );
